import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { Button } from '../Button';
import { Page } from '../Page';
import { PageEmptyState } from '../PageEmptyState';
import { PageErrorStateIcon } from './PageErrorStateIcon';
/** Renders page contents that indicate an error occurred, with an optional refresh button. */ export function PageErrorState(props) {
    const { title, onRefresh, skin, message, error, testId } = props, rest = _object_without_properties(props, [
        "title",
        "onRefresh",
        "skin",
        "message",
        "error",
        "testId"
    ]);
    useEffect(()=>{
        if (error) {
            // eslint-disable-next-line no-console
            console.error('PageErrorState error', error);
        }
    }, [
        error
    ]);
    return /*#__PURE__*/ _jsx(Page, _object_spread_props(_object_spread({
        header: title,
        skin: skin,
        testId: testId
    }, rest), {
        children: /*#__PURE__*/ _jsx(PageEmptyState, {
            illustration: /*#__PURE__*/ _jsx(PageErrorStateIcon, {}),
            message: message || 'Something went wrong. Refresh the page',
            actions: /*#__PURE__*/ _jsx(Button, {
                onClick: onRefresh,
                testId: "page-error-refresh-btn",
                children: "Refresh"
            })
        })
    }));
}
